<template>
  <v-dialog
    v-model="showModal"
    :persistent="loading"
    max-width="80%"
    class="pa-2"
  >
    <v-card>
      <modal-bar title="Información del cliente" @onClose="showModal = false" />
      <template v-if="loading">
        <v-skeleton-loader boilerplate type="table" class="mx-4 my-2" />
      </template>
      <div v-else class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <span class="mx-2 text-primary">
            <v-icon color="primary">mdi-account</v-icon> Datos del cliente
          </span>
          <div>
            <v-chip
              class="ma-2 text-white"
              active
              :color="data.channel == allchannels?.RETAIL ? 'red' : 'primary'"
            >
              {{ channelName }} | {{ data.channel }}
            </v-chip>
          </div>
        </div>
        <v-row class="text-left mx-3 my-2" dense>
          <v-col cols="12" sm="3" md="4"
            >Número o código de cliente: <br />
            <b>
              <v-chip class="ma-2" color="primary">
                {{ data.id }}
              </v-chip>
            </b>
            <br />
            Antigüedad: {{ calcYearsAndMonthsFromMonth(data.seniority).text }}
            <br />
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Dirección (completa): <br />
            <b
              >{{ data.address?.street }}, {{ data.address?.municipality }},
              {{ data.address?.state }}, {{ data.address?.postal_code }}</b
            >
            <v-btn
              :href="`https://www.google.com/maps/search/?api=1&query=${data.address?.latitude},${data.address?.longitude}`"
              target="_blank"
              color="success"
              icon
            >
              <v-icon>mdi-map-marker</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Estado: <br />
            <b>{{ data.address?.state }}</b>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Nombre del cliente: <br />
            <b>{{ data.name }}</b>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Municipio: <br />
            <b>{{ data.address?.municipality }}</b>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Colonia: <br />
            <b>{{ data.address?.colony ?? 'N/A' }}</b>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Asesor: <br />
            <b>{{ data.organization_chart?.seller_name }}</b>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Gerencia / Zona: <br />
            <b>{{ data.organization_chart?.manager_name }} / {{ data.zone }}</b>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Código postal: <br />
            <b>{{ data.address?.postal_code }}</b>
          </v-col>
        </v-row>
        <span class="mx-2 text-primary d-flex">
          <v-icon color="primary" class="mx-2"
            >mdi-card-account-details-outline</v-icon
          >
          Información de contacto
        </span>
        <v-row class="text-left mx-3 my-2" dense>
          <v-col cols="12" sm="3" md="4"
            >Teléfono: <br />
            <b>{{ formatPhone(data.contact?.phone) ?? 'N/A' }}</b>
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Correo electrónico: <br />
            <b
              ><a :href="`mailto:${data.contact?.email}`">{{
                data.contact?.email
              }}</a></b
            >
          </v-col>
          <v-col cols="12" sm="3" md="4"
            >Celular: <br />
            <b>{{ formatPhone(data.contact?.mobile) ?? 'N/A' }}</b>
          </v-col>
        </v-row>
        <receptions-table
          class="my-4"
          :customer-id="data.id"
          :customer-channel="data.channel"
          @receptionHasLoaded="setLastSeen"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import dates from '@/mixins/dates';
  import helpers from '@/mixins/helpers';
  import { Channels, ChannelNames } from '@/core/constants/channelConstants';
  import ReceptionsTable from '@/views/customers/components/ReceptionsTable.vue';
  import ModalBar from '@/components/modals/ModalBar.vue';

  export default {
    name: 'CustomerInfo',
    components: {
      ReceptionsTable,
      ModalBar,
    },
    mixins: [dates, helpers],
    props: {
      loading: {
        type: Boolean,
        required: true,
      },
      data: {
        type: Object,
        required: true,
      },
      value: {
        type: Boolean,
        required: true,
      },
      activeUsername: {
        type: String,
        required: true,
      },
    },

    computed: {
      allchannels() {
        return Channels;
      },
      channelName() {
        return ChannelNames[this.data.channel] || 'N/A';
      },
      showModal: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      setLastSeen(receptionData) {
        this.$emit('setLastSeen', {
          customer_id: this.data.id,
          channel: this.data.channel,
          name: this.data.name,
          zone: this.data.zone,
          reception_count: receptionData.length ?? 0,
        });
      },
    },
  };
</script>
